import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['field', 'content', 'trigger', 'flag']

  add () {
    if (this.hasFlagTarget) this.#setFlag(false)
    this.#setShown(true)
    if (this.hasFieldTarget) this.fieldTarget.focus()
  }

  remove () {
    if (this.hasFlagTarget) {
      this.#setFlag(true)
    } else if (this.hasFieldTarget) {
      this.fieldTarget.value = ''
      this.fieldTarget.dispatchEvent(new Event('change', { bubbles: true }))
    }
    this.#setShown(false)
  }

  #setFlag (removed) {
    this.flagTarget.value = removed ? '1' : '0'
    this.flagTarget.dispatchEvent(new Event('change', { bubbles: true }))
  }

  #setShown (shown) {
    this.contentTargets.forEach(el => { el.hidden = !shown })
    this.triggerTargets.forEach(el => { el.hidden = shown })
  }
}
